/* eslint-disable camelcase */
import * as React from 'react';
import { SearchZones, SearchZonesQuery, SearchZonesQueryVariables, Zone } from '@serodigital/ies-api-client';
import { getGqlClient } from '../../../shared/api-clients/gql';

export interface IZonesContext {
  zones: Zone[];
  getZoneDescription: (zone: Zone['zone_id']) => string;
}

export const ZonesContext = React.createContext<IZonesContext>(undefined);

export const ZonesProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const mountRef = React.useRef(true);
  const [zones, setZones] = React.useState<Zone[]>();

  const getZones = React.useCallback(async () => {
    const client = await getGqlClient();
    const res = await client.run<SearchZonesQuery, SearchZonesQueryVariables>(SearchZones, {});

    if (res.data.searchZones.itemCount && mountRef.current) {
      setZones(res.data.searchZones.items);
    }

    return res;
  }, []);

  React.useEffect(() => {
    getZones();
    return () => {
      mountRef.current = false;
    };
  }, []);

  return (
    <ZonesContext.Provider
      value={{
        zones,
        getZoneDescription: zone => zones?.find(({ zone_id }) => zone_id === zone)?.description,
      }}
    >
      {children}
    </ZonesContext.Provider>
  );
};

export const useZones = () => React.useContext(ZonesContext);
